<div class="row my-3 d-flex justify-content-start">
	<button
		*ngIf="addable"
		class="col-3 mx-5 btn theme-green-button"
		(click)="addEvent.emit($event)"
	>
		<i class="fs-5 bi bi-plus-lg" aria-hidden="true"></i> Ajouter
	</button>
</div>

<div class="row">
	<ul class="nav border-bottom">
		<li class="nav-item">
			<a
				class="nav-link theme-main-color"
				(click)="scrollTop()"
				[routerLink]="['/routes/etude']"
				[ngClass]="{
					'active fw-bold border-0 border-bottom border-3 theme-blue-border-color':
						router.isActive('/routes/etude', false)
				}"
				>Tournées en étude</a
			>
		</li>
		<li class="nav-item">
			<a
				class="nav-link theme-main-color"
				(click)="scrollTop()"
				[routerLink]="['/routes/attente']"
				[ngClass]="{
					'active fw-bold border-0 border-bottom border-3 theme-blue-border-color':
						router.isActive('/routes/attente', false)
				}"
				>Tournées en attente</a
			>
		</li>
		<li class="nav-item">
			<a
				class="nav-link theme-main-color"
				(click)="scrollTop()"
				[routerLink]="['/routes/en-cours']"
				[ngClass]="{
					'active fw-bold border-0 border-bottom border-3 theme-blue-border-color':
						router.isActive('/routes/en-cours', false)
				}"
				>Tournées en cours</a
			>
		</li>
		<li class="nav-item">
			<a
				class="nav-link theme-main-color"
				(click)="scrollTop()"
				[routerLink]="['/routes/list']"
				[ngClass]="{
					'active fw-bold border-0 border-bottom border-3 theme-blue-border-color':
						router.isActive('/routes/list', false)
				}"
				>Liste des tournées</a
			>
		</li>
	</ul>
</div>
